export const DEFAULT_AVAILABLE_CONSTRUCTION_YEARS = [
  { name: 'Allt', subName: '', value: '0' },
  { name: 'Gammalt', subName: '(före 1934)', value: '1' },
  { name: 'Funkis', subName: '(1934-1957)', value: '2' },
  { name: 'Folkhem', subName: '(1958-1964)', value: '3' },
  { name: 'Miljonprogram', subName: '(1965-1974)', value: '4' },
  { name: 'Osubventionerat', subName: '(1975-1993)', value: '5' },
  { name: 'Modernt', subName: '(1994-2009)', value: '6' },
  { name: 'Nyligen färdigställt', subName: '(2010 och senare)', value: '7' },
];
